import {create, StoreApi, UseBoundStore} from 'zustand';
import {persist} from 'zustand/middleware';

interface Store {
  data: Record<string, number>;
  changeColumnData: (key: string, value: number) => void;
  setDefaultData: (data: Record<string, number>) => void;
}

const stores: Record<string, UseBoundStore<StoreApi<Store>>> = {};

export function useTableColumnWidthStore(name: string): Store {
  if (!stores[name]) {
    stores[name] = create<Store>()(
      persist(
        (set) => ({
          data: {},
          changeColumnData: (key, value) => set((state) => ({data: {...state.data, [key]: value}})),
          setDefaultData: (data) => set(() => ({data})),
        }),
        {
          name: `table-column-width-store-${name}`,
        },
      ),
    );
  }

  const useStore = stores[name];
  return useStore();
}
